import React, { useMemo } from 'react';
import { Icon } from 'semantic-ui-react';
import SidebarItem from './SidebarItem';
import SessionContext from 'context/SessionContext';

function SidebarCategory({ name, icon, items, isExpanded, toggleExpand, clearSearch, onFavoriteChange }) {
  const session = React.useContext(SessionContext);

  // Filtramos los elementos según los permisos
  const visibleItems = useMemo(() => {
    return items.filter(item => !item.can || session.can(item.can));
  }, [items, session]);

  // Si no hay elementos visibles, no renderizamos la categoría
  if (visibleItems.length === 0) {
    return null;
  }

  return (
    <div className="sidebar-category">
      <div
        className="sidebar-category-header"
        onClick={toggleExpand}
        style={{
          padding: '12px 16px',
          color: 'white',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid rgba(255,255,255,0.1)'
        }}
      >
        <div>
          <Icon name={icon} style={{ marginRight: '8px' }} />
          <span>{name}</span>
        </div>
        <Icon name={isExpanded ? 'chevron down' : 'chevron right'} />
      </div>

      {isExpanded && (
        <div className="sidebar-category-items">
          {visibleItems.map((item, i) => (
            <SidebarItem
              {...item}
              key={i}
              clearSearch={clearSearch}
              isSubItem={true}
              onFavoriteChange={onFavoriteChange}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default SidebarCategory;